import React from 'react';

const AnimatedBackground = () => {
  return (
    <div className="absolute inset-0 overflow-hidden">
      {/* Dark gradient base */}
      <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900"></div>
      
      {/* Animated grid for depth */}
      <div className="grid-animated"></div>

      {/* Enhanced Electric Current Flow */}
      <svg className="electric-current-svg" xmlns="http://www.w3.org/2000/svg">
        <defs>
          {/* Enhanced electric pulse gradient */}
          <linearGradient id="electricPulse" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="rgba(59, 130, 246, 0)" />
            <stop offset="20%" stopColor="rgba(59, 130, 246, 0.3)" />
            <stop offset="40%" stopColor="rgba(59, 130, 246, 0.8)" />
            <stop offset="50%" stopColor="rgba(96, 165, 250, 1)" />
            <stop offset="60%" stopColor="rgba(59, 130, 246, 0.8)" />
            <stop offset="80%" stopColor="rgba(59, 130, 246, 0.3)" />
            <stop offset="100%" stopColor="rgba(59, 130, 246, 0)" />
          </linearGradient>
          
          {/* Strong glow effect */}
          <filter id="glow">
            <feGaussianBlur stdDeviation="4" result="coloredBlur"/>
            <feMerge>
              <feMergeNode in="coloredBlur"/>
              <feMergeNode in="coloredBlur"/>
              <feMergeNode in="SourceGraphic"/>
            </feMerge>
          </filter>
        </defs>
        
        {/* Multiple horizontal current lines for more animation */}
        <line className="electric-line line-h1" x1="0%" y1="15%" x2="100%" y2="15%" />
        <line className="electric-line line-h2" x1="0%" y1="35%" x2="100%" y2="35%" />
        <line className="electric-line line-h3" x1="0%" y1="55%" x2="100%" y2="55%" />
        <line className="electric-line line-h4" x1="0%" y1="75%" x2="100%" y2="75%" />
        <line className="electric-line line-h5" x1="0%" y1="85%" x2="100%" y2="85%" />
        
        {/* Diagonal current paths */}
        <line className="electric-line-diagonal line-d1" x1="0%" y1="20%" x2="100%" y2="80%" />
        <line className="electric-line-diagonal line-d2" x1="0%" y1="80%" x2="100%" y2="20%" />
        
        {/* Power nodes - pulsing connection points */}
        <circle className="power-node node-1" cx="15%" cy="15%" r="4" />
        <circle className="power-node node-2" cx="85%" cy="35%" r="4" />
        <circle className="power-node node-3" cx="30%" cy="55%" r="4" />
        <circle className="power-node node-4" cx="70%" cy="75%" r="4" />
        <circle className="power-node node-5" cx="50%" cy="85%" r="4" />
        
        {/* Vertical connection paths */}
        <line className="electric-line-vertical line-v1" x1="15%" y1="15%" x2="15%" y2="85%" />
        <line className="electric-line-vertical line-v2" x1="50%" y1="10%" x2="50%" y2="90%" />
        <line className="electric-line-vertical line-v3" x1="85%" y1="15%" x2="85%" y2="85%" />
      </svg>

      {/* Enhanced electric particles - more visible */}
      <div className="electric-particles-container">
        {[...Array(15)].map((_, i) => (
          <div
            key={i}
            className="electric-particle"
            style={{
              left: `${5 + i * 7}%`,
              top: `${20 + (i % 4) * 18}%`,
              animationDelay: `${i * 0.5}s`,
              animationDuration: `${6 + (i % 3) * 2}s`,
            }}
          ></div>
        ))}
      </div>

      {/* Enhanced pulse waves */}
      <div className="pulse-wave pulse-1"></div>
      <div className="pulse-wave pulse-2"></div>
      <div className="pulse-wave pulse-3"></div>

      {/* Additional electric sparks */}
      <div className="electric-sparks">
        {[...Array(8)].map((_, i) => (
          <div
            key={i}
            className="spark"
            style={{
              left: `${10 + i * 11}%`,
              top: `${25 + (i % 3) * 25}%`,
              animationDelay: `${i * 0.7}s`,
            }}
          ></div>
        ))}
      </div>
    </div>
  );
};

export default AnimatedBackground;
